import { DateObject } from 'src/app/models/common';

export class Organization {
  public ADDRESS1: string;
  public ADDRESS2: string;
  public CITY: string;
  public CODE: string;
  public COUNTRY: string;
  public CREATED_BY: string;
  public CREATED_DATE: string;
  public DEFAULT_CURRENCY_ID: string;
  public DONT_ALLOW_DICTIONARY_WORDS: boolean;
  public EAP: boolean;
  public EMAIL: string;
  public FAX_NO: string;
  public FAX_NO_EXT: number;
  public GRANTS: boolean;
  public ID: string;
  public IST: boolean;
  public IS_NUM_MANDATE_IN_PWD: boolean;
  public IS_PASSWORD_POLICY_APPLICABLE: boolean;
  public IS_SPC_CHAR_MANDATE_IN_PWD: boolean;
  public IS_UPPER_MANDATE_IN_PWD: boolean;
  public LANGUAGE_ID: string;
  public LAST_UPDATED_BY: string;
  public LAST_UPDATED_DATE: string;
  public LICENCE_END_DATE?: Date;
  public LICENCE_END_DATES: string;
  public LICENCE_END_DATEO: DateObject;
  public LOGIN_ATTEMPTS_TO_DISABLE: number;
  public LOGO: string;
  public MAIN_HEADER: string;
  public MIN_PASSWORD_LENGTH: number;
  public NAME: string;
  public NO_OF_PREV_PASS_MATCH_NEW_PWD: number;
  public OBS_CODE: string;
  public ORGANIZATION_ID: string;
  public PASSWORD_EXPIRY_DATE: number;
  public PHONE_NO: string;
  public PHONE_NO_EXT: number;
  public RECORD_STATE: number;
  public STATE: string;
  public SUB_HEADER: string;
  public WEB_SITE: string;
  public ZIP: string;
  public IST_CURRENCY_ID: string;
  public EAP_CURRENCY_ID: string;
  public CME_CURRENCY_ID: string;
  public CHARITABLE_CURRENCY_ID: string;
  public SPONSERSHIP_CURRENCY_ID: string;
  public FILEID: string;
  public FILENAME: string;
  public ACTIVE_USERS_LIMIT: number;
  public SPACE_ALLOCATION_BG: number;
  public DATAPEROID_IN_YEARS: number;
  public REPRESENTATIVE_NAME: string;
  public REPRESENTATIVE_EMAIL: string;
  public REPRESENTATIVE_PHONE_NO: string;
  public REPRESENTATIVE_PHONE_NO_EXT: number;
  public REPRESENTATIVE_ADDRESS: string;
  public ADMINISTRATOR_NAME: string;
  public ADMINISTRATOR_EMAIL: string;
  public ADMINISTRATOR_PHONE_NO: string;
  public ADMINISTRATOR_PHONE_NO_EXT: number;
  public ADMINISTRATOR_ADDRESS: string;
  public DSFILEID: string;  // Digital Signatue fileid
  public DSFILENAME: string;
  public AUTHTYPE: string; // SAML/LDAP/SSO/MED
  public FK_ACC_ATVY_EMAILID: string;
  public FK_CORRES_EMAILID: string;
  public IS_ANALYTICS_CONFIGURED: boolean;
  public LOGI_URL: string;
  public LOGI_CLIENTID: string;
  public LOGI_CLIENT_SECRET: string;
  public LOGI_SUPERVISOR_USERNAME: string;
  public LOGI_SUPERVISOR_PASSWORD: string;
  public LOGI_ADMIN_USERNAME: string;
  public LOGI_ADMIN_PASSWORD: string;
  public LOGI_ADMIN_ACCESSTOKEN: string;
  public IS_ORG_ACCOUNT_IN_LOGI: boolean;
  public CANREFRESH: boolean;

  public CHARITY: boolean;
  public SPONSERSHIP: boolean;
  public CME: boolean;
  public TIMEZONE: string;
  public IST_DISPLAY_NAME:string;
  public EAP_DISPLAY_NAME:string;
  public GRANTS_DISPLAY_NAME:string;
  public CME_DISPLAY_NAME:string;
  public CHARITY_DISPLAY_NAME:string;
  public SPONSERSHIP_DISPLAY_NAME:string;
}

export class SiteEvaluation {
  public ID: string
  public APPLICATION_ID: string
  public STUDY_CENTER_ID: string
  public EVALUATION_TYPE_ID: string
  public REPRESENTATIVE_ID: string
  public CONTACT_PERSON_ID: string
  public CONTACT_PERSON_DESIGNATION: string
  public EXPECTED_VISIT_DATE?: Date
  public ASSIGN_DATE: Date
  public NOTES: string
  public STATUS: number
  public ASSIGN_DATEO: DateObject;
  public EXPECTED_VISIT_DATEO: DateObject
}

export class MileStone {
  public ID: string;
  public APPLICATION_ID: string;
  public MILESTONE_NO: string;
  public STUDY_START_DATE?: Date;
  public STUDY_END_DATE?: Date;
  public TITLE: string;
  public NOTES: string;
  public STATUS: number;
  public STUDY_START_DATEO: DateObject
  public STUDY_END_DATEO: DateObject
}

export class Publications {
  public ID: string;
  public APPLICATION_ID: string;
  public TYPE_ID: string;
  public CONTENT_ID: string;
  public JOURNAL_NAME: string
  public TITLE: string
  public EXPECTED_DATE?: Date;
  public ANALYSIS_END_DATE?: Date
  public NOTES: string;
  public STATUS: number;
  public EXPECTED_DATEO: DateObject;
  public ANALYSIS_END_DATEO: DateObject;
}

export class ActivitySeminar {
  public ID: string;
  public APPLICATION_ID: string;
  public TYPE: string;
  public SUB_TYPE: string;
  public START_DATE?: Date;
  public END_DATE: Date;
  public TITLE: string;
  public AGENDA: string;
  public OVERVIEW: string;
  public NOTES: string;
  public STATUS: number;
  public START_DATEO: DateObject;
  public END_DATEO: DateObject;
}

export class Users {
  public ID: string;
  public CODE: string;
  public USER_TYPE: string;
  public EMAIL: string;
  public TITLE: string;
  public FIRST_NAME: string;
  public MIDDLE_NAME: string;
  public LAST_NAME: string;
  public SSN: string;
  public GENDER: string;
  public DESIGNATION: string;
  public PHONE: string;
  public PHONE_EXT: number;
  public ALTERNATIVE_PHONE: string;
  public ALTERNATIVE_PHONE_EXT: number;
  public DEPARTMENT_ID: string;
  public REPORT_TO_ID: string;
  public PASSWORD: string;
  public EXTERNAL_USER_ORGANIZATION: string;
  public DEFAULT_ID: string;
  public DEFAULT_DEPARTMENT_ID: string;
  public isChecked: boolean;
  public Status: boolean;
  public IsAdmin: boolean;
  public ROLEID: string;
  public ORGANIZATION_ID: string;
  public AUTHTYPE: string;
  public CreatedUserType: string;
}

export class EntityBase {
  public CREATED_BY: string;
  public CREATED_DATE: string;
  public LAST_UPDATED_BY: string;
  public LAST_UPDATED_DATE: string;
  public ORGANIZATION_ID: string;
  public OBS_CODE: string;
  public RECORD_STATE: number;
  public LANGUAGE_ID: string;
}

export class Role extends EntityBase {
  public ID: string;
  public Role_ID: string;
  public Role_Name: string;
  public CODE: string;
  public NAME: string;
  public DESCRIPTION: string;
  public TEMPLATE: string;
  public isChecked: boolean;
  public status: string;
  public USERID: string;
}

export class MODULE {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public FEATURE: FEATURE[];
}

export class FEATURE {
  public ID: string;
  public CODE: string;
  public NAME: string;
  public MODULE_ID: string;
  public PRIVILEGE: PRIVILEGE[];
}

export class PRIVILEGE {
  public ID: string;
  public FEATURE_ID: string;
  public PERMISSION_ID: string;
  public POSIBLE_RIGHTS: number;
  public PERMISSION_: PERMISSION;
  public isChecked: boolean;
  public isExisting: boolean;
  public ROLE_PRIVILEGEID: string;

}

export class PERMISSION {
  public ID: string;
  public NAME: string;
}

export class ROLE_PRIVILEGE {
  public ID: string;
  public ROLE_ID: string;
  public FEATURE_ID: string
  public PERMISSION_ID: string;
  public ACCESS_LEVEL: number;
  public CREATED_BY: string;
  public isExisting: boolean;
}

export class ROUTE {
  public ID: string;
  public COMMENTS: string;
  public ASSIGNED_TYPE: string
  public PERSON_ID: string;
  public PROGRAM_ID: string;
  public APPLICATION_ID: string;
  public STATUS: string;
  public MODULE: string;
}

export class RFI {
  public ID: string;
  public MODULE_ID: string;
  public APPLICATION_ID: string;
  public TITLE: string;
  public DETAILS: string;
  public STATUS: number;
  public CreatedDateStr: string;
  public Days: number;
  public RaisedBy: string;
  public RECORD_STATE: number;
  public Attachments: Attachment[];
}

export class RFI_COMMENT {
  public ID: string;
  public RFI_ID: string;
  public COMMENTS: string;
  public CreatedDateStr: string;
  public Days: number
  public RaisedBy: string;
  public IsSubmit: boolean;
  public Attachments: Attachment[];
}

export class Attachment {
  public FileID: string;
  public FileName: string;
  public DOCUMENT_NAME: string;
  public ID: string;
}

export class POLICY_HISTORY {
  public ID: string;
  public STATUS: string;
  public FROM_USER_NAME: string;
  public TO_USER_NAME: string;
  public COMMENTS: string;
  public CreatedDateStr: string;
  public Days: number
  public APPLICATION_STATUS: number;
  public APPLICATION_STATUS_Str: string;
}

export class NOTES {
  public ID: string;
  public APPLICATION_ID: string;
  public NOTES1: string;
  public MODULE_ID: string;
}

export class FAQ {
  public ID: string;
  // public CODE: string;
  public QUESTION: string;
  public ANSWER: string;
  public IS_FOR_IST: boolean;
  public IS_FOR_EAP: boolean;
  public IS_FOR_GRANTS: boolean;
  public RECORD_STATE: boolean;

}

export class CURRENCY {
  public ID: string;
  public NAME: string;
  public SYMBOL: string;
}


export class Role_Data extends EntityBase {
  public Role_ID: string;
  public Role_Name: string;
  public Status: boolean;
  public HasIST: boolean;
  public HasEAP: boolean;
  public HasGRANTS: boolean;
  public HasAnalytics: boolean;
  public IsDashboards: boolean;
  public IsDashboardBuilder: boolean;
  public IsSchedular: boolean;
  public lstGen: Role_Permissions[];
  public lstIST: Role_Permissions[];
  public lstEAP: Role_Permissions[];
  public lstGrants: Role_Permissions[];
  public HasCME: boolean;
  public HasCharity: boolean;
  public HasSponsership: boolean;
  public lstAnalytics: Role_Permissions[];
  public IstDisplayName :string;
  public GrantsDisplayName :string;
  public EapDisplayName :string;
}

export class Role_Permissions extends EntityBase {
  public Screen_Code: string;
  public Screen_Name: string;
  public IsViewApp: boolean;
  public IsAddApp: boolean;
  public IsManageApp: boolean;
  public IsDeleteApp: boolean;
  public IsChangeOwnerApp: boolean;
  public HasView: boolean;
  public HasAdd: boolean;
  public HasManage: boolean;
  public HasDelete: boolean;
  public HasChangeOwner: boolean;

  public HasDashboards: boolean;
  public HasDashboardBuilder: boolean;
  public HasSchedular: boolean;
}
